import { ReactNode } from 'react'

import { Color } from '../../constants'
import { StyleProps } from '../../utils/create-styles'
import { Div } from '../Div'
import { Flex } from '../Flex'
import { FormattedText } from '../FormattedText'
import { HoverCard } from '../HoverCard'
import { Link } from '../Link'
import { Text } from '../Text'

const FONT_SIZE = 14

export const ContentPageSidebarItem = (props: {
  hoverCardContent?: ReactNode
  label: string
  labelColor?: Color
  text?: string
  to?: string
  boldNumbers?: boolean
  children?: ReactNode
  styles?: StyleProps
}) => {
  const textContent = props.children ?? (
    <Text
      noWrap
      fontSize={FONT_SIZE}
      styles={{
        display: 'block',
        color: props.to ? Color.BLUE : undefined,
      }}
    >
      <FormattedText boldNumbers={props.boldNumbers}>
        {props.text ?? ''}
      </FormattedText>
    </Text>
  )

  const valueContent = props.hoverCardContent ? (
    <strong>{textContent}</strong>
  ) : (
    textContent
  )

  const itemContent = (
    <Flex
      styles={{
        width: '100%',
        alignItems: 'center',
        gap: 2,
        ...props.styles,
      }}
    >
      <Div styles={{ flex: '0 0 40%' }}>
        <Text
          fontSize={FONT_SIZE}
          color={props.labelColor ?? Color.DARKEST_MEDIUM_GREY}
        >
          {props.label}
        </Text>
      </Div>
      <Div styles={{ flex: '1', overflow: 'hidden' }}>
        {props.to ? <Link to={props.to}>{valueContent}</Link> : valueContent}
      </Div>
    </Flex>
  )

  return props.hoverCardContent ? (
    <HoverCard trigger={itemContent}>{props.hoverCardContent}</HoverCard>
  ) : (
    itemContent
  )
}
